import Img from '@/components/Img';
import styles from './HowItWorksSubtitle.module.scss';
import Button, { ButtonType } from '@/components/Button/Button';
import Text from '@/components/Text/Text';

interface IHowItWorksSubtitle {
  title: string,
  subtitle?: string;
  button: {
    id: number;
    title: string;
    type: ButtonType;
    link: string;
    iconName?: string;
  },
  cards: {
    id: number,
    title: string,
    description: string,
    icon: {
      id: number,
      alternativeText: string | null,
      width: number,
      height: number,
      url: string,
    }
  }[]
}

const HowItWorksSubtitle = ({ data }: { data: IHowItWorksSubtitle }) => (
  <section className={styles.personalization}>
    <div className={styles.titleContainer}>
      <Text
        tag='h3'
        className={styles.title}
      >
        {data.title}
      </Text>
      {data.subtitle && (
        <Text
          tag='p'
          className={styles.subtitle}
        >
          {data.subtitle}
        </Text>
      )}
    </div>

    <ul className={styles.personalization_list}>
      {data.cards.map((card) => (
        <li
          className={styles.personalization_card}
          key={card.id}
        >
          <Img
            src={card.icon.url}
            height={80}
            width={80}
            alt={card.icon.alternativeText || ''}
          />
          <Text
            tag='h5'
            className={styles.cardTitle}
          >
            {card.title}
          </Text>
          <p>{card.description}</p>
        </li>
      ))}
    </ul>
    {data.button && (
      <div className={styles.primaryButtonContainer}>
        <Button
          type={data.button.type}
          href={data.button.link}
          iconName={data.button.iconName}
        >
          {data.button.title}
        </Button>
      </div>
    )}
  </section>
);

export default HowItWorksSubtitle;
